<script>
	export let config;
</script>